import * as signalR from "@microsoft/signalr";
import { getEnvVariable } from 'config/helpers';
import { getAccessToken } from "features/auth";

let connection: signalR.HubConnection | null = null;

export const getSignalRConnection = (): signalR.HubConnection => {
  if (!connection) {
    const token = getAccessToken() || "";

    const webSockeUrl_ = getEnvVariable('REACT_APP_ADMIN_WEB_SOCKET_URL') ;
    const webSocketUrl = webSockeUrl_;

    connection = new signalR.HubConnectionBuilder()
      .withUrl(webSocketUrl, {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

      // KeepAlive settings
    connection.keepAliveIntervalInMilliseconds = 15000;
    connection.serverTimeoutInMilliseconds = 60000;

       connection.onclose(async () => {

     // console.warn("🔴 SignalR disconnected, trying to restart");

      let retry = 0;
      while (retry < 10) {
        try {
          await connection!.start();   // Non-null now
          //console.log("🟢 SignalR reconnected");
          break;
        } catch (e) {
          retry++;
          await new Promise(res => setTimeout(res, 5000));
        }
      }
    });
  }

 
  return connection;
};

// export const getSignalRConnection = (): signalR.HubConnection => {
//   if (!connection) {   
//     const token = getAccessToken() ; 
//     const webSocketUrl = "https://atulitapi.intigate.co.in/chathub" ;
//     //getEnvVariable('REACT_APP_ATULIT_API_WEB_SOCKET_URL') ;
    
//     connection = new signalR.HubConnectionBuilder()
//       .withUrl(webSocketUrl, {
//         accessTokenFactory: () => token ?? "",
//       })
//       .withAutomaticReconnect()
//       .configureLogging(signalR.LogLevel.Information)
//       .build();

//     // Start the connection
//     connection.start() ;
//       // .then(() => {

//       //   console.info("✅ SignalR Connected12");
//       //   // if (process.env.NODE_ENV === "development") {
//       //   //   // eslint-disable-next-line no-console
          
//       //   // }
//       // })
//       // .catch((err) => {

//       //   console.error("❌ SignalR Connection Error:", err);
//       //   if (process.env.NODE_ENV === "development") {
//       //     // eslint-disable-next-line no-console
//       //     console.error("❌ SignalR Connection Error:", err);
//       //   }
//       // });
//   }

//   return connection;
// };

export const stopSignalRConnection = async (): Promise<void> => {
  if (connection) {
    await connection.stop();
    connection = null;
  }
};


